<template>
    <section class="context flow__panel">
        <div class="context__main">
            <h2 class="context__title">
                Plan Builder Context Viewer
            </h2>
            <p class="context__text">
                This is a helper page to aid debugging by providing non-sensitive context information.
            </p>
            <div class="context_scheme-map">
                <h3>Presentation Scheme Map</h3>
                <pre>{{ presentationSchemeMap }}</pre>
            </div>
            <div class="context_presentation-scheme">
                <h3>Presentation Scheme</h3>
                <pre>{{ presentationScheme }}</pre>
            </div>
            <div class="context_serviced-scheme">
                <h3>Serviced Scheme</h3>
                <pre>{{ servicedScheme }}</pre>
            </div>
            <div class="context_plugin-scheme">
                <h3>Plugin Scheme</h3>
                <pre>{{ pluginScheme }}</pre>
            </div>
        </div>
    </section>
</template>

<script>
import _ from 'lodash'

import SchemeServicingManager from '@/scheme-servicing-manager'

export default {

    data() {
        return {
            pluginScheme: null,
            presentationScheme: null,
            presentationSchemeMap: null,
            servicedScheme: null,
        }
    },

    async mounted() {
        this.pluginScheme = _.cloneDeep(this.$scheme)
        this.presentationScheme = _.cloneDeep(await SchemeServicingManager.getPresentationSchemeAsync())
        this.presentationSchemeMap = _.cloneDeep(SchemeServicingManager.getSchemeMap())
        this.servicedScheme = 'Data not yet available'

        this.pluginScheme.segmentKeymap = 'REDACTED'
        this.pluginScheme.resources = 'REDACTED'
        this.pluginScheme.progressComponent = 'REDACTED'
        this.pluginScheme.navigationItems = 'REDACTED'

        this.presentationScheme.segmentKeymap = 'REDACTED'
        this.presentationScheme.resources = 'REDACTED'
        this.presentationScheme.progressComponent = 'REDACTED'
        this.presentationScheme.navigationItems = 'REDACTED'

        this.presentationSchemeMap.analyticsId = 'REDACTED'
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

</style>
